import Layout from '../modules/Layout';
import SystemStatus from '../modules/SystemStatus';
import { CustomNextPage } from '../lib/types';
import { useQuery } from '@apollo/client';
import { systemAlertsQuery } from '../core-types';
import { bootstrap } from '../lib/bootstrap';
import { SYSTEM_ALERTS_QUERY } from '../lib/core/SystemAlertsQuery';

const SystemStatusPage: CustomNextPage = props => {
  const { url } = props;

  // We enable this feature flag to show the system status page

  // if (!systemConfig.featureFlags.enableSystemAlerts) {
  //   const err = new Error(`Page not found`);
  //   err.code = 'ENOENT';
  //   throw err;
  // }

  const { data, loading } = useQuery<systemAlertsQuery>(SYSTEM_ALERTS_QUERY);

  const title = 'System status';
  return (
    <Layout
      title={title}
      url={url}
      loading={loading}
      contentProps={{
        // Override Content defaultProps
        py: 0,
        mx: 0,
        my: 5
      }}
      render={() => {
        if (!data || !data.systemAlerts || !data.systemClosureAlerts) {
          const err = new Error(`Page not found`);
          err.code = 'ENOENT';
          throw err;
        }
        return <SystemStatus data={data} {...props} />;
      }}
    />
  );
};

export default bootstrap(SystemStatusPage);
